const KYCLevelBannerBackground = () => {
    return (
        <svg width="170" height="91" viewBox="0 0 170 91" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_8970_3540" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="170" height="91">
                <path d="M0 0H158C164.627 0 170 5.37258 170 12V79C170 85.6274 164.627 91 158 91H0V0Z" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_8970_3540)">
                <path d="M94.2113 60.3855L94.2114 60.3854C100.968 50.5153 113.493 46.3507 124.823 50.1991L124.823 50.1993L124.835 50.2031L174.453 65.6378C178.105 66.7738 179.512 71.1982 177.186 74.2344L119.477 149.564C117.855 151.681 114.948 152.33 112.58 151.102L58.6859 123.169C55.7526 121.649 54.8121 117.903 56.6793 115.178L94.2113 60.3855Z" stroke="#D6D6D6"/>
                <path d="M136.586 40.1902L136.587 40.188C144.695 28.0879 159.966 23.0301 173.679 27.8855L200.299 38.3643L134.619 140.535L92.5302 135.58L80.232 123.333L136.586 40.1902Z" stroke="#D6D6D6"/>
            </g>
        </svg>
    )
}

export default KYCLevelBannerBackground
